import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ProjectsVisibilityGroupResponse } from '../../models/response/projects-visibility-group-response-input.model';
import { AccountConfigurationService } from '../../services/account-configuration.service';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { ProjectVisibilityDialogComponent } from '../create-group-visibility-dialog/project-visibility-dialog.component';
import { MessageDialogModalDialog } from '../errors-dialog/message-dialog-modal';
import { NotificationService } from '../../services/notification-service';
import { Subscription } from 'rxjs';
import DialogDataDto from '../../models/new-file-dialog-dto';

@Component({
  selector: 'project-visibility-group',
  templateUrl: './project-visibility-group.component.html',
  styleUrls: ['./project-visibility-group.component.scss']
})
export class ProjectVisibilityGroupComponent implements OnInit, OnDestroy {

  private notifySubscription: Subscription;
  dataSourceVisibilityGroup: ProjectsVisibilityGroupResponse[] = [];
  displayedColumnsGroupVisibility: string[] = ['groupVisibility', 'actions'];

  constructor(
    private accountConfigurationService: AccountConfigurationService,
    public dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private notificationService: NotificationService) {

  }

  ngOnDestroy(): void {
    this.notifySubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.notifySubscription = this.notificationService.notify.subscribe(() => {
      this.reloadData();
    });

    let account = localStorage.getItem("acc");

    this.accountConfigurationService.getProjectsVisibilityGroup(account).subscribe({
      next: (data) => {
        this.dataSourceVisibilityGroup = data;
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  async onClickNewConfiguration(): Promise<void> {
    const dialogData = new DialogDataDto(null, this.getEmailList());
    this.dialog.open(ProjectVisibilityDialogComponent, {
      data: dialogData
    })
  }

  editVisibilityGroup(dataSourceVisibilityGroup: ProjectsVisibilityGroupResponse) {
    if (dataSourceVisibilityGroup) {
      const dialogData = new DialogDataDto(dataSourceVisibilityGroup, this.getEmailList());
      this.dialog.open(ProjectVisibilityDialogComponent, {
        data: dialogData
      });
    }
  }

  deleteVisibilityGroup(id: string) {
    let account = localStorage.getItem("acc");

    const dialogRef = this.dialog.open(MessageDialogModalDialog, {
      data: {
        title: "visibility.messages.alertTitle",
        message: "visibility.messages.deleteMessage",
        isError: false,
        isConfirmDialog: true
      }
    });

    dialogRef.afterClosed().subscribe(confirm => {
      if (!confirm)
        return;

      this.accountConfigurationService.deleteProjectsVisibilityGroup(account, id).subscribe({
        next: () => {
          this.reloadData();
        },
        error: (error) => {
          if (error.status == 400) {
            this.dialog.open(MessageDialogModalDialog, {
              data: {
                title: "visibility.messages.alertTitle",
                message: "visibilityRequest.errors.userIsNotAnAccountAdministrator",
                isError: true
              }
            });
          }
          if (error.status == 500) {
            this.dialog.open(MessageDialogModalDialog, {
              data: {
                title: "visibility.messages.alertTitle",
                message: "visibilityRequest.errors.errorOnDelete",
                isError: true
              }
            });
          }
        }  
      });
    });
  }

  reloadData() {
    this.dataSourceVisibilityGroup = [];
    this.ngOnInit();
    this.changeDetectorRef.detectChanges();
  }

  getEmailList(): string[] {
    const emails: string[] = this.dataSourceVisibilityGroup
      .reduce((accumulator, data) => accumulator.concat(data.Users), []);

    return emails;
  }
}
